var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('compensation-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var proposal = ref.proposal;
var affiliateLink = ref.affiliateLink;
var discountCodes = ref.discountCodes;
var proposalStep = ref.proposalStep;
var patchProposalStep = ref.patchProposalStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isPatchingProposal = ref.isPatchingProposal;
var isCompletingProposal = ref.isCompletingProposal;
var errors = ref.errors;
return [_c('proposal-compensation-view',{attrs:{"campaign":campaign,"proposal-step":proposalStep,"proposal":proposal,"affiliate-link":affiliateLink,"discount-codes":discountCodes,"is-loading":isLoading,"is-completing-proposal":isCompletingProposal,"errors":errors},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchProposalStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }